// import Activities from './components/activities/Activities';
import ClientFlowDropdowns from './components/dropdowns/client-flow-dropdowns/Dropdowns';
import OnboardingButtons from './components/onboardingButtons/OnboardingButtons';
import * as S from './RightSidebar.styled';

type RightSidebarProps = {
    clientFlow: boolean;
    onboarding: boolean;
    mobile: boolean;
    closeMenu?: () => void;
};

export default function RightSidebar({
    clientFlow,
    onboarding,
    mobile,
    closeMenu,
}: RightSidebarProps) {
    return (
        <>
            {clientFlow ? (
                <S.SidebarContainerDropdowns mobile={mobile}>
                    <ClientFlowDropdowns />
                </S.SidebarContainerDropdowns>
            ) : onboarding ? (
                <OnboardingButtons closeMenu={closeMenu} />
            ) : (
                // <S.SidebarContainerActivities>
                //     <Activities />
                // </S.SidebarContainerActivities>
                <></>
            )}
        </>
    );
}
